import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux/es/exports";
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from "react-i18next";
import Button from "../../components/Button";
import {MdOutlineDataSaverOff} from "react-icons/md";
import saveUser, {getUserById} from "../../services/userService";
import {getList} from "../../services/service";
import {FaEye} from "@react-icons/all-files/fa/FaEye";
import {FaEyeSlash} from "@react-icons/all-files/fa/FaEyeSlash";
import ComboboxComponent from "../../components/Combobox";
import UserFileUpload from "../../components/UserFileUpload";
import InputMask from "react-input-mask-3.0";
import {toast} from "react-toastify";
import {fetchDataSupplier} from "../../services/supplierService";

const SUPPLIER_ROLES = ["SUPPLIER_OWNER", "SUPPLIER_MANAGER"];


const AddUser = ({t}) => {
    const {token} = useSelector((state) => state.user);
    const navigate = useNavigate();
    const {id} = useParams();
    const [form, setForm] = useState({
        fullName: "",
        username: "",
        password: "",
        newPassword: null,
        phone: "",
        role: null,
        imageId: null,
        supplierId: null,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [hiddenPassword, setHiddenPassword] = useState(false);
    const [passwordType, setPasswordType] = useState("password");
    const [newPasswordType, setNewPasswordType] = useState("password");
    const [selectedItem, setSelectedItem] = useState(null);
    const [image, setImage] = useState({
        preview:
            "https://cdn-icons-png.flaticon.com/512/149/149071.png",
        data: null,
    });

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        setIsLoading(true);
        const response = await saveUser(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/user/`,
            token,
            {
                id: id ? id : null,
                fullName: evt.target.fullName.value,
                username: evt.target.username.value,
                phone: evt.target.phone.value,
                role: form.role ? form.role : "MANAGER",
                password: evt.target.password ? evt.target.password.value : null,
                newPassword: evt.target.newPassword ? evt.target.newPassword.value : null,
                imageId: form.imageId ? form.imageId : null,
                supplierId: SUPPLIER_ROLES.includes(form.role) ? form.supplierId : null,
            },
            image.data
        );
        if (response.success) {
            setIsLoading(false);
            navigate("/user");
            toast.success(id ? t('action.edit_success') : t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : "null",
                },
            });
        }
    };

    const fetchDataById = async () => {
        const response = await getUserById(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/user/${id}`,
            token
        );
        if (response.success) {
            setImage({
                preview: response.data.imageId
                    ? `${process.env.REACT_APP_HOST_BASE_URL}/v1/file/user/${response.data.imageId}`
                    : "https://cdn-icons-png.flaticon.com/512/149/149071.png",
                data: "",
            });
            setForm({
                fullName: response.data.fullName,
                username: response.data.username,
                phone: response.data.phone || "",
                role: response.data.role,
                imageId: response.data.imageId,
                supplierId: response.data.supplierId || null,
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        fetchDataRole();
        fetchSuppliers();
        if (id) {
            fetchDataById();
            setHiddenPassword(true);
        } else {
            return;
        }
    }, []);

    const fetchSuppliers = async () => {
        const response = await fetchDataSupplier(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/supplier/table`,
            token,
            {
                draw: 1,
                start: 0,
                length: 1000,
                recordsTotal: 0,
                columns: [],
                order: [{column: "name", dir: "ASC"}],
                search: {value: "", regex: false},
                filter: {},
            }
        );
        if (response.success) {
            setSuppliers(response.data.data.map((s) => ({id: s.id, name: s.name})));
        }
    };

    const fetchDataRole = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/user/enum/role/type`,
            token
        );
        if (response.success) {
            setRoles(response.data);
        } else {
            alert(response.message);
        }
    };

    useEffect(() => {
        if (suppliers.length > 0 && form.supplierId) {
            const found = suppliers.find((s) => s.id === form.supplierId);
            setSelectedSupplier(found || null);
        }
    }, [suppliers, form.supplierId]);

    const onchange = (value) => {
        setForm({
            ...form,
            role: value.name,
            supplierId: SUPPLIER_ROLES.includes(value.name) ? form.supplierId : null,
        });
        if (!SUPPLIER_ROLES.includes(value.name)) {
            setSelectedSupplier(null);
        }
    };

    const onSupplierChange = (value) => {
        setSelectedSupplier(value);
        setForm({...form, supplierId: value ? value.id : null});
    };

    /*password hidden or not */
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }
    const newTogglePassword = () => {
        if (newPasswordType === "password") {
            setNewPasswordType("text")
            return;
        }
        setNewPasswordType("password")
    }
    /*password hidden or not */


    const onNewPassword = (value) => {
        setForm({...form, newPassword: value.name});
    };

    const onHandlePhone = (value) => {
        setForm({...form, phone: value.name});
    };

    const getFileImage = (file) => {
        setImage({
            preview: URL.createObjectURL(file),
            data: file
        })
    };

    return (
        <>
            <div className="px-4 py-4 sm:px-6 lg:px-8">
                <h1 className="mb-5 text-xl font-semibold text-gray-900">
                    {id ? `${t(`table.user.update_user`)}` : `${t(`table.user.add_user`)}`}
                </h1>
                <form onSubmit={handleSubmit}>
                    <div className="overflow-hidden shadow sm:rounded-md">
                        <div className="px-10 py-5 bg-white sm:p-6">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-3">
                                    <label
                                        htmlFor="fullName"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`table.user.full_name`)}
                                    </label>
                                    <input
                                        type="text"
                                        name="fullName"
                                        id="fullName"
                                        required
                                        autoComplete="fullName"
                                        defaultValue={form?.fullName}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <br/>
                                <div className="col-span-6 sm:col-span-3">
                                    <label
                                        htmlFor="username"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`table.user.username`)}
                                    </label>
                                    <input
                                        type="email"
                                        name="username"
                                        id="username"
                                        required
                                        autoComplete="username"
                                        defaultValue={form?.username}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <br/>
                                <div className="col-span-6 sm:col-span-3">
                                    <label
                                        htmlFor="phone"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t(`table.user.phone`)}
                                    </label>
                                    <InputMask
                                        name="phone"
                                        className="py-2 px-3 w-full border border-2 focus:border-indigo-500 rounded-md px-2 shadow-sm sm:text-sm outline-none "
                                        mask="+\9\98\(99) 999-99-99"
                                        value={form?.phone}
                                        onChange={onHandlePhone}/>
                                </div>
                                <br/>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="password"
                                           className="block text-sm font-medium text-gray-700 mb-3">
                                        {t(`table.user.password`)}
                                    </label>
                                    <div className="mt-1 flex rounded-md shadow-sm">
                                        <input
                                            type={passwordType}
                                            name="password"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-sm sm:text-sm border-gray-300"
                                            placeholder="********"
                                        />
                                        <button type="button"
                                                className="inline-flex items-center px-2.5 py-1.5 border border-transparent border-blue-500 text-xs font-medium rounded text-indigo-700 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                onClick={togglePassword}
                                        >
                                            {passwordType === "password" ? <FaEyeSlash className="h-4 w-4"/> :
                                                <FaEye className="h-4 w-4"/>}
                                        </button>
                                    </div>
                                </div>
                                <br/>
                                {
                                    hiddenPassword ?
                                        <div className="col-span-6 sm:col-span-3">
                                            <label htmlFor="newPassword"
                                                   className="block text-sm font-medium text-gray-700 mb-3">
                                                {t(`table.user.new_password`)}
                                            </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <input
                                                    type={newPasswordType}
                                                    name="newPassword"
                                                    className="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-sm sm:text-sm border-gray-300"
                                                    placeholder="********"
                                                    onChange={onNewPassword}

                                                />
                                                <button type="button"
                                                        className="inline-flex items-center px-2.5 py-1.5 border border-transparent border-blue-500 text-xs font-medium rounded text-indigo-700 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                        onClick={newTogglePassword}
                                                >
                                                    {newPasswordType === "password" ?
                                                        <FaEyeSlash className="h-4 w-4"/> :
                                                        <FaEye className="h-4 w-4"/>}
                                                </button>
                                            </div>
                                        </div>
                                        : null
                                }
                                <br/>
                                <div className="col-span-6 sm:col-span-3">
                                    <ComboboxComponent
                                        label={t('table.user.role')}
                                        data={roles}
                                        onChange={onchange}
                                        item={selectedItem}/>
                                </div>
                                <br/>
                                {SUPPLIER_ROLES.includes(form.role) && (
                                    <>
                                        <div className="col-span-6 sm:col-span-3">
                                            <ComboboxComponent
                                                label={t('table.user.supplier')}
                                                data={suppliers}
                                                onChange={onSupplierChange}
                                                item={selectedSupplier}/>
                                        </div>
                                        <br/>
                                    </>
                                )}
                                <div className="col-span-6 sm:col-span-3 mb-10">
                                    <label
                                        className="block text-sm font-medium text-gray-700 mb-3">{t(`action.upload`)}</label>
                                    <UserFileUpload url={"/v1/file/user/"}
                                                    defaultUrl={image.preview}
                                                    fileId={null}
                                                    getFileImage={getFileImage}/>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end px-4 py-3 text-right bg-gray-50 sm:px-6">
                            <Button type="button" to="/user" btnName={t(`backward`)}/>

                            <button
                                type="submit"
                                className="text-white bg-blue-700 hover:bg-blue-800  font-medium rounded-lg text-sm px-5 py-1.5 text-center  dark:bg-blue-600 dark:hover:bg-blue-700  inline-flex items-center"
                            >
                                {t(`save`)}
                                {isLoading ? (
                                    <svg
                                        role="status"
                                        className="inline w-4 h-4 ml-1 text-white animate-spin"
                                        viewBox="0 0 100 101"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="#E5E7EB"
                                        />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                ) : (
                                    <MdOutlineDataSaverOff className="w-4 h-4 ml-1"/>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};
export default withTranslation()(AddUser);
